import Icon from "./Icon";

const CONFIRMATION_THEMES = {
  danger: {
    icon: "delete",
    iconColor: "text-error bg-error/15 border-error/20",
    btnColor: "bg-error text-white hover:opacity-90",
  },
  warning: {
    icon: "warning",
    iconColor: "text-tier-gold bg-tier-gold/15 border-tier-gold/20",
    btnColor: "bg-tier-gold text-white hover:opacity-90",
  },
  info: {
    icon: "info",
    iconColor: "text-primary bg-primary/15 border-primary/20",
    btnColor: "bg-primary text-white hover:opacity-90",
  },
  success: {
    icon: "check_circle",
    iconColor: "text-success bg-success/15 border-success/20",
    btnColor: "bg-success text-white hover:opacity-90",
  },
};

export default function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Evet, Devam Et",
  cancelText = "Vazgeç",
  type = "info",
}) {
  if (!isOpen) return null;

  const theme = CONFIRMATION_THEMES[type] || CONFIRMATION_THEMES.info;

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-[2px] flex items-center justify-center p-4 z-[999] animate-fade-in">
      <div className="bg-white rounded-3xl shadow-modal border border-outline-variant max-w-md w-full p-6 animate-scale-up space-y-4">
        <div className="flex items-start gap-4">
          <div className={`w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0 border ${theme.iconColor}`}>
            <Icon name={theme.icon} className="!text-[24px]" />
          </div>
          <div className="flex-1 space-y-1">
            <h3 className="font-bold text-lg text-on-surface leading-snug">{title}</h3>
            <p className="text-sm text-on-surface-variant leading-relaxed">{message}</p>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 pt-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-xs font-semibold text-on-surface border border-outline-variant bg-white rounded-xl hover:bg-surface-container-high transition"
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className={`px-4 py-2 text-xs font-semibold rounded-xl transition ${theme.btnColor}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
